export default __webpack_public_path__ + "static/media/inventoryMgmt.4b2fe291.png";